import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import { isEmpty } from 'lodash';

import styles from './style.module.scss';

export default function CommonIssues({ issues, isLoading, noDataAvailable }) {
  return (
    <div className={styles.commonIssues}>
      <div className={styles.headerContainer}>
        <span className={styles.problemIcon}>
          <ReportProblemIcon color="error" />
        </span>
        <h2>Common Issues - Action Needed</h2>
      </div>
      {noDataAvailable && !isLoading && (
        <p className={styles.insightsText}>
          No insights available. Please generate insights.
        </p>
      )}
      {isLoading ? (
        <CircularProgress className={styles.loadingIndicator} />
      ) : isEmpty(issues) && !noDataAvailable ? (
        <p>No common issues found</p>
      ) : (
        issues.map((issue, idx) => (
          <div className={styles.issueCard} key={idx}>
            <div className={styles.issueHeader}>
              <h3>{issue.name}</h3>
              <span>{issue.students.length} students</span>
            </div>
            <p>{issue.description}</p>
            <p>
              <strong>Students:</strong>{' '}
              {issue.students.length > 0 ? issue.students.join(', ') : '—'}
            </p>
          </div>
        ))
      )}
    </div>
  );
}
